// @ts-expect-error - TS2724 - '"redux"' has no exported member named 'CombinedReducer'. Did you mean 'combineReducers'?
import { combineReducers, type CombinedReducer } from 'redux';

import type { Action } from './access-types/project-access-action-creators';
import accessTypes, {
	defaultState as defaultEntityState,
} from './access-types/project-access-types-entity-reducer';
import contextReducer, {
	defaultState as defaultContextState,
} from './context/project-access-context-reducer';
import fieldReducer, { defaultUiState } from './field/project-access-field-reducer';
import type { State } from './project-access-types';

export const initialState: State = {
	ui: defaultUiState,
	entities: defaultEntityState,
	context: defaultContextState,
};

const reducerFunction: CombinedReducer<State, Action> = combineReducers({
	ui: fieldReducer,
	entities: accessTypes,
	context: contextReducer,
});

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: State = initialState, action: Action): State =>
	reducerFunction(state, action);
